module.exports = __webpack_public_path__ + "static/media/icon-arrow-white.4135fbeb.svg";